import { fetchCA } from 'helpers/utils'

export const apiFetchBulletin = async (page, limit) => {
  const response = await fetchCA('/bulletin-messages', { page, limit })
  return { 
    messages: response, 
    totalCount: response.length > 0 ? response[0].total_count : 0 
  }
}
